import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import t from "../../components/I18N/TranslateHelpers";
import {RootState} from "../../app/RootReducer";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import NewsletterForm from "./NewsletterForm";
import {getUserAccount, subscribeToNewsletter} from "../User/UsersSlice";

const NewsletterFormContainer : React.FC = () => {
  const dispatch = useDispatch();
  const isRequesting = useSelector((state:RootState) => state.userRdc.isRequesting);
  const isSuccess = useSelector((state:RootState) => state.userRdc.isRequestSuccess);
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const userDetail = useSelector((state: RootState) => state.userRdc.userDetail)

  const onSubmit = (data: any) => {
    dispatch(subscribeToNewsletter(data.newsletterNameFirstname, data.newsletterEmail));
  }
  useEffect(() => {
      if (userDetail && userDetail.userName !== null) {
        dispatch(getUserAccount());
      }
    }, []
  );

  return (
    <>
      {
        isSuccess ?
          <div className="container py-5">
            <div className="alert alert-success" role="alert">
              {t('register_newsletter_success')}
            </div>
          </div>
          :
          isRequesting ?
            <SpinnerOnTop/>
            :
            isAuthenticated && userDetail?.customer?.subscribedToNewsletter ? null :
              <NewsletterForm onSubmit={onSubmit} userDto={userDetail?.customer ?? null} userEmail={userDetail?.customer?.email ?? ''}/>
      }
    </>
  )
}

export default NewsletterFormContainer;
